module.exports = __webpack_public_path__ + "img/loadVideo1.d70509d5.gif";